import React from 'react';
import { Flex, Heading, Button } from 'rebass';
import Field from 'components/Field';
import { confirmPasswordHandler } from 'utils/validateHandlers';
import ErrorMessage from 'components/ErrorMessage';
import { EMPLOYER } from 'constants/index';
import { UserRoleType } from 'types/global';

interface UserInfoStepProps {
  userRole: UserRoleType;
  allFomValues?: any;
  hasValidationErrors: any;
  handleSubmit: any;
  submitting?: boolean;
  submitError: string;
}

const UserInfoStep: React.FC<UserInfoStepProps> = (props): JSX.Element => {
  const {
    userRole,
    allFomValues: { password },
    handleSubmit,
    submitting,
    submitError,
  } = props;

  const accountType = userRole === EMPLOYER ? 'Employer' : 'Agency';

  const confirmPasswordValidate = confirmPasswordHandler(password);

  return (
    <Flex flexDirection="column" alignItems="center" py={7} px={4}>
      {submitError && <ErrorMessage>{submitError}</ErrorMessage>}
      <Heading fontSize={['36px']} fontWeight={5} textAlign="center" mb={5}>
        Start setting up your {accountType} account
      </Heading>
      <Field
        name="firstName"
        label="First Name"
        maxLength={100}
        inputType="text"
        required
        labelAsterisk
      />
      <Field name="lastName" label="Last Name" required labelAsterisk />
      <Field name="email" label="Work Email" inputType="email" required labelAsterisk />
      <Field
        name="password"
        label="Password"
        inputType="password"
        pattern="((?=.*\d)(?=.*[A-Z]).{7,15})[^!@#$%':;{}\[\]`|/\\?~§±^*()_]"
        patternMismatch="The password should be min 8 characters long, and must contain at least 1 capital letter, and Number (0 to 9). No special characters are allowed"
        required
        labelAsterisk
      />
      <Field
        name="confirmPassword"
        label="Confirm Password"
        inputType="password"
        required
        labelAsterisk
        validate={confirmPasswordValidate}
      />
      <Button
        variant={submitting ? 'disabled' : 'primary'}
        mt={2}
        onClick={handleSubmit}
        disabled={submitting}
      >
        Next
      </Button>
    </Flex>
  );
};

export default UserInfoStep;
